import React from 'react';
import { Facebook, Instagram, MapPin, Phone, Mail, Droplets } from 'lucide-react';
export function Footer() {
  const scrollToQuote = () => {
    document.getElementById('quote')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer id="contact" className="bg-primary text-white pt-20 pb-8 border-t border-white/10" data-id="element-16">
      <div className="container mx-auto px-4 md:px-6" data-id="element-17">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 text-center md:text-left" data-id="element-18">
          {/* Brand Col */}
          <div className="flex flex-col items-center md:items-start" data-id="element-19">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-20">
              <span className="font-heading font-bold text-3xl tracking-tight text-white uppercase" data-id="element-21">
                Pressure Perfect
              </span>
            </a>
            <p className="text-white/70 text-lg mb-8 max-w-xs" data-id="element-22">
              Professional exterior cleaning and restoration services. We make
              filthy surfaces look brand new.
            </p>
            <div className="flex items-center gap-4" data-id="element-23">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent hover:text-white transition-colors" data-id="element-24">
                <Facebook className="w-5 h-5" data-id="element-25" />
                <span className="sr-only" data-id="element-26">Facebook</span>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent hover:text-white transition-colors" data-id="element-27">
                <Instagram className="w-5 h-5" data-id="element-28" />
                <span className="sr-only" data-id="element-29">Instagram</span>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent hover:text-white transition-colors" data-id="element-30">
                <Droplets className="w-5 h-5" data-id="element-31" />
                <span className="sr-only" data-id="element-32">Google Reviews</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-33">
            <h4 className="font-heading text-xl font-bold mb-6 uppercase tracking-wider text-accent" data-id="element-34">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-35">
              <li data-id="element-36">
                <a href="#services" className="text-white/70 hover:text-white transition-colors text-lg" data-id="element-37">
                  Services
                </a>
              </li>
              <li data-id="element-38">
                <a href="#contact" className="text-white/70 hover:text-white transition-colors text-lg" data-id="element-39">
                  About
                </a>
              </li>
              <li data-id="element-40">
                <button onClick={scrollToQuote} className="text-white/70 hover:text-white transition-colors text-lg" data-id="element-41">
                  Request Quote
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-start" data-id="element-42">
            <h4 className="font-heading text-xl font-bold mb-6 uppercase tracking-wider text-accent" data-id="element-43">
              Contact Us
            </h4>
            <ul className="space-y-6" data-id="element-44">
              <li data-id="element-45">
                <a href="tel:+15551234567" className="flex items-center gap-3 text-white/90 hover:text-accent transition-colors text-lg group" data-id="element-46">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-accent/20" data-id="element-47">
                    <Phone className="w-5 h-5" data-id="element-48" />
                  </div>
                  (555) 123-4567
                </a>
              </li>
              <li data-id="element-49">
                <a href="mailto:hello@pressureperfect.com" className="flex items-center gap-3 text-white/90 hover:text-accent transition-colors text-lg group" data-id="element-50">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-accent/20" data-id="element-51">
                    <Mail className="w-5 h-5" data-id="element-52" />
                  </div>
                  hello@pressureperfect.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/90 text-lg" data-id="element-53">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center" data-id="element-54">
                  <MapPin className="w-5 h-5" data-id="element-55" />
                </div>
                Serving Phoenix and surrounding areas
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-white/50 text-sm" data-id="element-56">
          <p data-id="element-57">
            &copy; {new Date().getFullYear()} Pressure Perfect. All rights
            reserved.
          </p>
          <p data-id="element-58">Managed by LetLois</p>
        </div>
      </div>
    </footer>;
}